export default "__VITE_ASSET__$$NMMLl3__"